import React from 'react';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import CircularProgress from '@mui/material/CircularProgress';

import OnboardingLayout from '../../components/layouts/OnboardingLayout';
import OnboardingLayoutBox from '../../components/layouts/OnboardingLayoutBox';
import SignUpAcceptingPaymentsForm from '../../components/forms/SignUpAcceptingPaymentsForm';
import { useHandleRegistrationFlowRedirect } from '../../hooks/registration';
// import StepIndicatorOnboarding from '../../components/common/StepIndicatorOnboarding/StepIndicatorOnboarding';
import { H1 } from '../../components/atoms';

const Fallback = () => (
  <Box display="flex" justifyContent="center">
    <CircularProgress size={24} />
  </Box>
);

const SignUpAcceptingPayments = () => {
  const { t } = useTranslation();
  useHandleRegistrationFlowRedirect();

  return (
    <OnboardingLayout theme="dark">
      <OnboardingLayoutBox theme="dark">
        <Box mb="40px">
          {/* <StepIndicatorOnboarding currentStep={3} stepsCount={9} /> */}
          <H1 fontWeight={700}>{t('Are you currently accepting payments?')}</H1>
        </Box>
        <React.Suspense fallback={<Fallback />}>
          <SignUpAcceptingPaymentsForm />
        </React.Suspense>
      </OnboardingLayoutBox>
    </OnboardingLayout>
  );
};

export default SignUpAcceptingPayments;
